module.exports = __webpack_public_path__ + "img/202504_07.d1c73f24.jpg";